import { styled } from "styled-components";

import { colorCSS, fontSizes, radius } from "../../styles";

export const CaptionWrapper = styled.div<{
    roundedCorners?: string;
}>(
    {
        overflow: "hidden",
        position: "relative"
    },
    ({ roundedCorners }) => {
        if (!roundedCorners) return "";
        const key = roundedCorners.toLowerCase();
        // @ts-expect-error - dynamic key access
        const radiusValue = radius[key];
        return radiusValue ? `border-radius: ${radiusValue};` : "";
    }
);

export const Caption = styled.div<{ appearance: string }>(
    {
        "fontSize": fontSizes.sm,
        "lineHeight": 1.25,
        "h1, h2, h3, h4, h5, h6, p": {
            "margin": "0 0 0.275rem",
            "&:last-child": {
                marginBottom: 0
            }
        },
        "strong": {
            fontWeight: 500
        }
    },
    ({ appearance }) =>
        appearance == "Overlay 1" &&
        `
      background-color: ${colorCSS("P500", 0.75)};
      bottom: 0;
      color: ${colorCSS("N0")};
      left: 0;
      padding: 1rem;
      position: absolute;
      right: 0;
    `
);
